import { Receipt } from '@/components/custom/ui/clients/tempula/payment/receipt'
import { tempulaPaymentConfig } from '@/constant/config/clients/tempula/payment/paymentConfig'
import { createFileRoute } from '@tanstack/react-router'
import { SEO } from '@/constant/config/clients/tempula/seo'

const { title, description } = SEO.receipt

export const Route = createFileRoute('/_clients/tempula/receipt')({
    head: () => ({
        meta: [
            { title },
            { name: 'description', content: description },
            { name: 'robots',      content: 'noindex, nofollow' },
        ],
    }),
    component: RouteComponent,
})

const receiptConfig = {
  businessName: tempulaPaymentConfig.businessName,
  homeRoute: "/tempula/home",
  heroImageUrl: tempulaPaymentConfig.hero.imageUrl,
  heroTag: tempulaPaymentConfig.hero.tag,
};

function RouteComponent() {
  return <Receipt config={receiptConfig} />
}
